import { LegalDocumentsCard } from "./LegalDocumentsCard";
import { useMe } from "./AdminShell";

/** Superadmin: Hey Life app-wide Datenschutz / Impressum / AGB (Me → App tab). */
export function AppLegalDocumentsCard({ canEdit }: { canEdit: boolean }) {
  const me = useMe();
  if (!me.data?.isSuperadmin) return null;
  return (
    <LegalDocumentsCard
      scope="app"
      canEdit={canEdit}
      churchName=""
      listQueryKey={["admin", "legal", "app"]}
      fetchPath="/admin/platform/legal"
      patchPath={(kind) => `/admin/platform/legal/${kind}`}
      titleKey="admin.settings.legalApp"
    />
  );
}
